import {
  type ParkingSpot,
  type ParkingSpotRevenueRow,
} from '@pigello/pigello-matrix';
import { createBaseRentHandler } from './shared-base-rent-handler';

// Custom handler for parking spot to include revenue rows
export const handleCustomParkingSpotNestedCase = createBaseRentHandler<
  ParkingSpot,
  ParkingSpotRevenueRow
>('parkingspotrevenuerow');
